module.exports = __webpack_public_path__ + "static/img/Michalanney.a268aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michalanney.jpg
// module id = U2CY
// module chunks = 0